<template>
  <a-card>
    <template slot="title">
      <div class="flex-left">
        <div class="tile"></div>
        <strong class="margin-left-10">VID: {{ chart_data.name }}</strong>
      </div>
    </template>
    <div class="modern-chart-container">
      <div ref="chart" class="chart-inner"></div>
    </div>
    <a-row class="margin-top-10">
      <a-button type="primary" @click="get_gebv_chart_data" :loading="loading">查看代际GEBV数据统计</a-button>
    </a-row>
    <div v-show="show_gebv_chart" class="width-100 margin-top-10">
      <div ref="gebv_chart" class="gebv-chart-inner"></div>
    </div>
  </a-card>
</template>

<script>
export default {
  props: {
    chart_data: {
      type: Object, default: () => {}
    }
  },
  data() {
    return {
      height: 100,
      show_gebv_chart: false,
      loading: false
    }
  },
  mounted() {
    this.draw(this.chart_data)
  },
  methods: {
    draw(tree_data) {
      const my_chart = this.$echarts.init(this.$refs.chart);
      const series = {
        type: "tree",
        data: [tree_data],
        name: tree_data.vid,
        top: "5%",
        left: "5%",
        bottom: "5%",
        right: "5%",
        symbolSize: 12,
        symbol: 'circle',
        layout: "radial",
        roam: true,
        expandAndCollapse: false,
        initialTreeDepth: 2,
        itemStyle: {
          borderWidth: 2,
          shadowBlur: 4,
          shadowColor: 'rgba(0, 0, 0, 0.1)',
          shadowOffsetY: 2
        },
        lineStyle: {
          color: '#d9d9d9',
          width: 1.5,
          curveness: 0.5
        },
        label: {
          position: "left",
          verticalAlign: "middle",
          align: "right",
          fontSize: 11,
          color: '#595959',
          fontWeight: 500,
          distance: 6
        },
        leaves: {
          label: {
            position: "right",
            verticalAlign: "middle",
            align: "left",
          },
        },
        emphasis: {
          focus: "descendant",
          itemStyle: {
            borderWidth: 2,
            shadowBlur: 8,
            shadowColor: 'rgba(0, 0, 0, 0.2)'
          },
          lineStyle: {
            width: 2
          },
          label: {
            fontWeight: 600
          }
        },
        animationDuration: 400,
        animationDurationUpdate: 500,
      }

      let option = {
        backgroundColor: '#fff',
        tooltip: {
          trigger: "item",
          triggerOn: "mousemove",
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          borderColor: '#e8e8e8',
          borderWidth: 1,
          padding: [8, 12],
          textStyle: {
            color: '#333',
            fontSize: 12
          }
        },
        series: series,
      };

      this.$nextTick(() => {
        my_chart.setOption(option)
      })
    },
    async get_gebv_chart_data() {
      this.loading = true
      const res = await this.$api.get_gebvs_by_generations(this.chart_data.name)
      this.loading = false
      this.show_gebv_chart = true

      this.$nextTick(() => {

        const gebv_chart = this.$echarts.init(this.$refs.gebv_chart);
        console.log(gebv_chart);
    
        let option = {
          title: [
            {
              text: `${this.chart_data.name}代际GEBV变化`,
              left: 'center'
            }
            
          ],
          dataset: [
            {
              source: res.data
            },
            {
              transform: {
                type: 'boxplot',
                config: { itemNameFormatter: '{value}代' }
              }
            },
            {
              fromDatasetIndex: 1,
              fromTransformResult: 1
            }
          ],
          tooltip: {
            trigger: 'item',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            left: '10%',
            right: '10%',
            bottom: '15%'
          },
          xAxis: {
            type: 'category',
            boundaryGap: true,
            nameGap: 30,
            splitArea: {
              show: false
            },
            splitLine: {
              show: false
            }
          },
          yAxis: {
            type: '',
            name: 'gebv',
            splitArea: {
              show: true
            }
          },
          series: [
            {
              name: 'boxplot',
              type: 'boxplot',
              datasetIndex: 1
            },
            {
              name: 'outlier',
              type: 'scatter',
              datasetIndex: 2
            }
          ]
        }
        this.$nextTick(() => {
          gebv_chart.setOption(option)
        })
      })
    }
  },
}
</script>

<style scoped>
.modern-chart-container {
  width: 100%;
  height: 800px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 0 1px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.chart-inner {
  width: 100%;
  height: 100%;
}

.gebv-chart-inner {
  width: 100% !important;
  height: 300px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 0 1px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
</style>